import React from 'react';
import useDidUpdateEffect from '@use-effect/did-update';

import useFilters, { Project, type ActiveFilter } from 'Common/hooks/useFilters';

import Main from 'Elements/Main';
import { CheckboxInputProps } from 'Elements/Input/Checkbox';

import SearchHeroBanner, { SearchHeroBannerProps } from 'Modules/HeroBanner/Search';
import SearchFilters, { FiltersSearchProps } from 'Modules/Filters/Search';

export interface Props {
    heroBanner: SearchHeroBannerProps;
    tabs: FiltersSearchProps['tabs'];
    filters: CheckboxInputProps[];
    searchResults: FiltersSearchProps['listing'];
    selectedProject: Project;
    activeSearchTerm?: string;
    initialActiveFilters: ActiveFilter[];
}

const Search: React.FC<Props> = props => {
    const {
        heroBanner,
        tabs,
        filters,
        searchResults,
        selectedProject,
        activeSearchTerm,
        initialActiveFilters = []
    } = props;

    const {
        activeFilters,
        searchTerm,
        activeProject,
        filterResults,
        setSearchTerm,
        setActiveProject,
        generateCheckboxOptions,
        resetActiveFilters
    } = useFilters(initialActiveFilters, activeSearchTerm, selectedProject);

    useDidUpdateEffect(() => {
        filterResults();
    }, [activeFilters, searchTerm, activeProject]);

    return (
        <Main>
            <SearchHeroBanner
                {...heroBanner}
                search={{
                    ...heroBanner.search,
                    handleSubmit: value => setSearchTerm(value)
                }}
            />
            <SearchFilters
                tabs={tabs}
                listing={searchResults}
                handleProjectSelect={project => {
                    resetActiveFilters();
                    setActiveProject(project);
                }}
                activeProject={activeProject}
                contentTypesFilters={generateCheckboxOptions(filters, 'filter')}
            />
        </Main>
    );
};

export default Search;
